var learnMoreMiniCart = document.querySelectorAll('body:not(.template-cart) .c-postcode-pop-up__link'),
    learnMoreCart = document.querySelectorAll('.template-cart .c-postcode-pop-up__link'),
    learnMoreProduct = document.querySelectorAll('#hc-message'),
    bagMiniCart = document.querySelectorAll('.cart-view-btn'),
    checkoutMiniCart = document.querySelectorAll('body:not(.template-cart) .Cart__Checkout'),
    checkoutCart = document.querySelectorAll('.template-cart .Cart__Checkout'),
    notLoadedCheckout = true,
    notLoadedViewBag = true,
    screenView, totalBasketPrice;

function checkScreenSize(){
    if (window.innerWidth < 768) {
        screenView = "mobile";
    } else {
        screenView = "desktop";
    }
    return screenView;
}

window.dataLayer = window.dataLayer || [];

function how_it_works_mini_cart(){
    screenView = checkScreenSize();
    window.dataLayer.push({
        event: "hc_how_it_works_mini_cart",
        eventCategory: "Harper",
        screen: screenView
    });
}

function how_it_works_product_page() {
    screenView = checkScreenSize();
    window.dataLayer.push({
        event: "hc_how_it_works_product_page",
        eventCategory: "Harper",
        screen: screenView
    });
}

function how_it_works_mini_cart() {
    screenView = checkScreenSize();
    window.dataLayer.push({
        event: "hc_how_it_works_mini_cart",
        eventCategory: "Harper",
        screen: screenView
    });
}

function how_it_works_cart() {
    screenView = checkScreenSize();
    window.dataLayer.push({
        event: "hc_how_it_works_cart",
        eventCategory: "Harper",
        screen: screenView
    });
}

function hc_postcode_search_mini_cart() {
    screenView = checkScreenSize();
    var postcode = document.querySelector('#postcode').value.replace(/ /g, '');
    fetch('https://staging.api.harperconcierge.com/api/check-postcode/' + postcode)
    .then((response) => {
        if (response.ok) {
            window.dataLayer.push({
                event: "hc_postcode_search_mini_cart",
                postcode: postcode,
                eventCategory: "Harper",
                screen: screenView
            });
        } else {
            window.dataLayer.push({
                event: "hc_postcode_search_error_mini_cart",
                postcode: postcode,
                eventCategory: "Harper",
                screen: screenView
            });
        }
    })
}

function hc_postcode_search_cart() {
    screenView = checkScreenSize();
    var postcode = document.querySelector('#postcode').value.replace(/ /g, '');
    fetch('https://staging.api.harperconcierge.com/api/check-postcode/' + postcode)
    .then((response) => {
        if (response.ok) {
            window.dataLayer.push({
                event: "hc_postcode_search_cart",
                postcode: postcode,
                eventCategory: "Harper",
                screen: screenView
            });
        } else {
            window.dataLayer.push({
                event: "hc_postcode_search_error_cart",
                postcode: postcode,
                eventCategory: "Harper",
                screen: screenView
            });
        }
    })
}

function view_bag_mini_cart() {
    if (notLoadedViewBag) {
        screenView = checkScreenSize();
        window.dataLayer.push({
            event: "hc_view_bag_mini_cart",
            eventCategory: "Harper",
            screen: screenView
        });
        notLoadedViewBag = false;
    }
}

function view_checkout_mini_cart() {
    screenView = checkScreenSize();
    if (notLoadedCheckout){
        window.dataLayer.push({
            event: "hc_view_checkout_mini_cart",
            eventCategory: "Harper",
            screen: screenView
        });
        notLoadedCheckout = false;
    }
}

function view_checkout_cart() {
    screenView = checkScreenSize();
    if (notLoadedCheckout) {
        window.dataLayer.push({
            event: "hc_view_checkout_cart",
            eventCategory: "Harper",
            screen: screenView
        });
        notLoadedCheckout = false;
    }
}

function hc_view_harper_mini_cart() {
    screenView = checkScreenSize();
    totalBasketPrice = document.querySelector('.Cart__Total span').innerHTML;
    window.dataLayer.push({
        event: "hc_view_harper_mini_cart",
        eventCategory: "Harper",
        screen: screenView,
        basketTotal: totalBasketPrice
    });
}

function hc_view_harper_cart() {
    screenView = checkScreenSize();
    totalBasketPrice = document.querySelector('.Cart__Total span').innerHTML;
    window.dataLayer.push({
        event: "hc_view_harper_cart",
        eventCategory: "Harper",
        screen: screenView,
        basketTotal: totalBasketPrice
    });
}

if (bagMiniCart.length > 0){
    bagMiniCart[0].addEventListener('click', view_bag_mini_cart);
}
if (checkoutMiniCart.length > 0){
    checkoutMiniCart[0].addEventListener('click', view_checkout_mini_cart);
}
if (checkoutCart.length > 0) {
    checkoutCart[0].addEventListener('click', view_checkout_cart);
}
if (learnMoreMiniCart.length > 0){
    learnMoreMiniCart[0].addEventListener('click', how_it_works_mini_cart);
}
if (learnMoreProduct.length > 0){
    learnMoreProduct[0].addEventListener('click', how_it_works_product_page);
}
if (learnMoreCart.length > 0) {
    learnMoreCart[0].addEventListener('click', how_it_works_cart);
}


